import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 50%;
  min-height: 100vh;
  background-color: ${Colors.Neutral10};

  ${Media.Phone`
    background-color: transparent;
  `};

  ${Media.Laptop`
    width: 100%;
    margin: 0 auto;
  `};

  ${Media.Desktop`
    max-width: 860px;
  `};
`
